import { CLIENT_APPTS_LIST } from '../../../route-names';

export const getSelectedItemFromCurrentRoute = currentRouteName => {
  let selectedItem: string = null;
  type matcher = { pattern: RegExp, value: string };
  // This is pretty fragile, if someone ever adds a route or modifies a route name they
  // need to know that this checker exists if it needs to
  const matchers: matcher[] = [
    {
      pattern: /^home/,
      value: 'home',
    }, {
      pattern: /^search|^profile_edit|^profile/,
      value: 'search',
    }, {
      pattern: RegExp(`^${CLIENT_APPTS_LIST}|^consumer.appointment_status_details`, ''),
      value: 'appts',
    }, {
      pattern: /^consumer.accounts|consumer.account.promotions_list|consumer.account.profile/,
      value: 'account',
    },
    {
      pattern: /^consumer.more/,
      value: 'more',
    },
  ];

  matchers.some(matcher => {
    const hasMatch = matcher.pattern.test(currentRouteName);
    if (hasMatch) {
      selectedItem = matcher.value;
      return hasMatch;
    }
    return hasMatch;
  });

  return selectedItem;
};
